<template>
  <page-header-wrapper>
    <template v-slot:content>
      <a-card>
        <div
          style="
            display: flex;
            margin-bottom: 10px;
            flex-wrap: wrap;
            width: 100%;
            justify-content: space-between; /* 子元素向左对齐 */
            /* 子元素占满整个交叉轴 */
          "
        >
          <div
            v-for="(a, i) in statisTicsIist.RenAmount"
            :key="i"
            class="gutter-box guttersr"
            :style="a.colors"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px;
              margin: 10px 0;
              border-radius: 10px;
              width: 30%;
            "
          >
            <div class="left" style="width: 90%">
              <div style="font-size: 20px; margin: 10px 0; font-weight: bold">{{ a.title }}</div>
              <div style="font-size: 20px; margin: 10px 0; font-weight: bold; color: red">
                {{ a.count }}
              </div>
            </div>
            <a-icon
              :type="a.icon"
              :style="{ 'font-size': '2rem', color: a.color, display: 'inline-block', width: '50px', height: '60px' }"
            />
          </div>
        </div>
      </a-card>
      <a-card>
        <a-row>
          <a-col :span="12">
            <div style="position: absolute; left: 18%; top: 0px; padding: 5px;z-index:100">
              <a-range-picker valueFormat="YYYY-MM-DD" @change="orderAmountDateChange" size="small" />
            </div>
            <div id="orderAmountChart" style="height: 400px"></div>
          </a-col>

          <a-col :span="12">
            <div style="position: absolute; left: 18%; top: 0px; padding: 5px;z-index:100">
              <a-range-picker valueFormat="YYYY-MM-DD" @change="orderCountDateChange" size="small" />
            </div>
            <div id="orderCountChart" style="height: 400px"></div>
          </a-col>
        </a-row>
      </a-card>
    </template>
  </page-header-wrapper>
</template>

<script>
import { timeFix } from '@/utils/util'
import * as echarts from 'echarts'
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import { getUserProfile } from '@/api/system/user'
import { goodsResult, homeResult, advertResult, courseResult } from '@/api/statistics/home'
import { orderAmountChart } from '@/api/statistics/order'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper,
  },
  data() {
    return {
      dataList: {
        today: {},
        yesterday: {},
      }, //首页看板
      advert: {}, //广告
      goodsShare: {}, //商品
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: '',
        },
      },
      statisTicsIist: {
        RenAmount: [
          {
            title: '课程视频数',
            count: 0,
            icon: 'money-collect',
            color: '#dd5a5a',
            colors: 'background:rgb(207 34 34 / 23%)',
          },
          {
            title: '课程点击数',
            count: 0,
            icon: 'money-collect',
            color: '#491ca1',
            colors: 'background:rgb(0 0 255 / 16%)',
          },
          {
            title: '课程付费人数',
            count: 0,
            icon: 'user-add',
            color: 'green',
            colors: 'background:rgb(11 185 104 / 23%)',
          },
          {
            title: '课程总收益',
            count: 0,
            icon: 'user-add',
            color: '#faad14',
            colors: 'background:rgb(255 212 0 / 23%)',
          },
          {
            title: '付费课程数',
            count: 0,
            icon: 'account-book',
            color: 'rgb(96 126 143)',
            colors: 'background:rgb(32 41 108 / 24%)',
          },
          {
            title: '当天收益',
            count: 0,
            icon: 'account-book',
            color: 'rgb(105 209 10)',
            colors: 'background:rgb(99 203 4 / 24%)',
          },
        ],
      },

      orderAmountParam: {
        chartType: 'days',
        dateRange: [],
        startTime: undefined,
        endTime: undefined,
      },
      orderCountParam: {
        chartType: 'days',
        dateRange: [],
        startTime: undefined,
        endTime: undefined,
      },
      /*销售数据选择*/
      isOrderSelect: 'days',
      isOrderCountSelect: 'days',
      roleGroup: {},
      postGroup: {},
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname']),
  },
  created() {
    // this.getUser()
    this.getHomeStatistics()
    // this.getAdvertResult();
    // this.getGoodResult();
  },
  mounted() {
    this.drawOrderAmountChart()
    this.drawOrderCountChart()
  },
  methods: {
    // 获取用户信息
    getUser() {
      getUserProfile().then((response) => {
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    getHomeStatistics() {
      courseResult().then((response) => {
        this.dataList.today = response.data.today
        console.log(this.dataList)
        this.statisTicsIist.RenAmount[0].count = response.data.today.orderCount
        this.statisTicsIist.RenAmount[1].count = response.data.today.userCount
        this.statisTicsIist.RenAmount[2].count = response.data.today.goodsCount
        this.statisTicsIist.RenAmount[3].count = response.data.today.goodsAmount
        this.statisTicsIist.RenAmount[4].count = response.data.today.refundCount
        this.statisTicsIist.RenAmount[5].count = response.data.today.orderAmount
      })
    },
    getAdvertResult() {
      advertResult().then((response) => {
        this.advert = response.data
      })
    },
    getGoodResult() {
      goodsResult().then((response) => {
        this.goodsShare = response.data
      })
    },

    orderAmountDateChange(val) {
      this.orderAmountParam.startTime = val[0] + ' 00:00:00'
      this.orderAmountParam.endTime = val[1] + ' 23:59:59'
      this.drawOrderAmountChart()
    },
    orderCountDateChange(val) {
      this.orderCountParam.startTime = val[0] + ' 00:00:00'
      this.orderCountParam.endTime = val[1] + ' 23:59:59'
      this.drawOrderCountChart()
    },
    handelOrderClick(val) {
      this.isOrderSelect = val
      this.orderAmountParam.chartType = val
      this.drawOrderAmountChart()
    },
    handelOrderCountClick(val) {
      this.isOrderCountSelect = val
      this.orderCountParam.chartType = val
      this.drawOrderCountChart()
    },

    drawOrderAmountChart() {
      // // 添加
      var chartDom = document.getElementById('orderAmountChart')
      var myChart = echarts.init(chartDom)
      var option
      orderAmountChart(this.orderAmountParam).then((res) => {
        if (res.code === '20001') {
          let yaxis = res.data.yyAxis
          let xAxis = res.data.xxAxis
          option = {
            title: {
              text: '付费人数趋势图',
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#1890ff',
                },
              },
            },
            areaStyle: {
              smooth: true,
            },
            legend: {
              data: ['订单销售额', '运费金额', '退款金额'],
            },
            toolbox: {
              feature: {
                saveAsImage: {},
              },
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                data: xAxis,
                axisLabel: {
            rotate: 45, // 标签旋转45度
            interval: 0 // 显示所有标签
        }
              },
            ],
            yAxis: [
              {
                type: 'value',
              },
            ],
            series: [
              // {
              //   name: '运费金额',
              //   type: 'line',
              //   stack: 'shippingAmount',
              //   label: {
              //     normal: {
              //       show: true,
              //       formatter: function(params) {
              //         // 当数值为0时不显示标签
              //         if (params.value === 0) {
              //           return '';
              //         } else if (params.value === '0.00') {
              //           return '';
              //         }
              //         return params.value;
              //       }
              //     }
              //   },
              //   areaStyle: {
              //     color: {
              //       type: 'linear',
              //       x: 0,
              //       y: 0,
              //       x2: 0,
              //       y2: 1,
              //       colorStops: [{
              //         offset: 0, color: 'rgba(211,89,13,0.5)'    // 0% 处的颜色
              //       }, {
              //         offset: 1, color: 'rgba(197,105,67,0)' //   100% 处的颜色
              //       }],
              //       global: false // 缺省为 false
              //     }
              //   },
              //   lineStyle: {
              //     color: '#ee8e22' // 这里设置
              //   },
              //   itemStyle: { // 设置标点的默认样式
              //     normal: {
              //       color: '#ee8e22' // 设置标点的颜色为蓝色
              //     }
              //   },
              //   emphasis: {
              //     focus: 'series'
              //   },
              //   data: yaxis.shippingPayAmountList
              // },
              // {
              //   name: '退款金额',
              //   type: 'line',
              //   stack: 'refundAmount',
              //   lineStyle: {
              //     color: '#f30202' // 这里设置
              //   },
              //   itemStyle: { // 设置标点的默认样式
              //     normal: {
              //       color: '#f30202' // 设置标点的颜色为蓝色
              //     }
              //   },
              //   label: {
              //     normal: {
              //       show: true,
              //       formatter: function(params) {
              //         // 当数值为0时不显示标签
              //         if (params.value === 0) {
              //           return '';
              //         } else if (params.value === '0.00') {
              //           return '';
              //         }
              //         return params.value;
              //       }
              //     }
              //   },
              //   areaStyle: {
              //     color: {
              //       type: 'linear',
              //       x: 0,
              //       y: 0,
              //       x2: 0,
              //       y2: 1,
              //       colorStops: [{
              //         offset: 0, color: 'rgba(218,119,119,0.5)'    // 0% 处的颜色
              //       }, {
              //         offset: 1, color: 'rgba(239,5,5,0)' //   100% 处的颜色
              //       }],
              //       global: false // 缺省为 false
              //     }
              //   },
              //   emphasis: {
              //     focus: 'series'
              //   },
              //   data: yaxis.refundAmountList
              // },
              {
                name: '收益曲线图',
                type: 'line',
                stack: 'orderCountList',
                smooth: true,
                lineStyle: {
                  color: '#1890ff', // 这里设置
                },
                itemStyle: {
                  // 设置标点的默认样式
                  normal: {
                    color: '#1890ff', // 设置标点的颜色为蓝色
                  },
                },
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#1890ff', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgba(123,203,96,0)', //   100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // 当数值为0时不显示标签
                      if (params.value === 0) {
                        return ''
                      } else if (params.value === '0.00') {
                        return ''
                      }
                      return params.value
                    },
                  },
                },
                emphasis: {
                  focus: 'series',
                },
                data: yaxis.payAmountList,
              },
            ],
          }

          option && myChart.setOption(option)
        }
      })
    },

    drawOrderCountChart() {
      // // 添加
      var chartDom = document.getElementById('orderCountChart')
      var myChart = echarts.init(chartDom)
      var option
      orderAmountChart(this.orderCountParam).then((res) => {
        if (res.code === '20001') {
          let yaxis = res.data.yyAxis
          let xAxis = res.data.xxAxis
          option = {
            title: {
              text: '收益曲线图',
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#e5b961',
                },
              },
            },
            legend: {
              data: ['订单量', '退款量'],
            },
            toolbox: {
              feature: {
                saveAsImage: {},
              },
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                data: xAxis,
                axisLabel: {
            rotate: 45, // 标签旋转45度
            interval: 0 // 显示所有标签
        }
              },
            ],
            yAxis: [
              {
                type: 'value',
              },
            ],
            series: [
              // {
              //   name: '退款量',
              //   type: 'line',
              //   lineStyle: {
              //     color: '#f30202' // 这里设置
              //   },
              //   itemStyle: { // 设置标点的默认样式
              //     normal: {
              //       color: '#f30202' // 设置标点的颜色为蓝色
              //     }
              //   },
              //   label: {
              //     normal: {
              //       show: true,
              //       formatter: function(params) {
              //         // 当数值为0时不显示标签
              //         if (params.value === 0) {
              //           return '';
              //         } else if (params.value === '0.00') {
              //           return '';
              //         } else {
              //           return params.value;
              //         }
              //       }
              //     }
              //   },
              //   stack: 'refundCount',
              //   areaStyle: {
              //     color: {
              //       type: 'linear',
              //       x: 0,
              //       y: 0,
              //       x2: 0,
              //       y2: 1,
              //       colorStops: [{
              //         offset: 0, color: 'rgba(238,177,184,0.5)'    // 0% 处的颜色
              //       }, {
              //         offset: 1, color: 'rgba(255,0,0,0)' //   100% 处的颜色
              //       }],
              //       global: false // 缺省为 false
              //     }
              //   },
              //   emphasis: {
              //     focus: 'series'
              //   },
              //   data: yaxis.refundCountList
              // },
              {
                name: '付费人数曲线图',
                type: 'line',
                stack: 'payAmountList',
                smooth: true,

                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#e5b961', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: 'rgba(123,203,96,0)', //   100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
                lineStyle: {
                  color: '#e5b961', // 这里设置
                },
                itemStyle: {
                  // 设置标点的默认样式
                  normal: {
                    color: '#e5b961', // 设置标点的颜色为蓝色
                  },
                },
                label: {
                  show: true,
                  position: 'top',
                },
                emphasis: {
                  focus: 'series',
                },
                data: yaxis.orderCountList,
              },
            ],
          }

          option && myChart.setOption(option)
        }
      })
    },

    onSponsorTabChange(key, type) {
      this[type] = key
    },
  },
}
</script>

<style lang="less" scoped>
//@import "./index.less";

blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.project-list {
  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {
  .project-list {
    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

.home {
  blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    font-size: 17.5px;
    border-left: 5px solid #eee;
  }

  hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
  }

  .col-item {
    margin-bottom: 20px;
  }

  ul {
    padding: 0;
    margin: 0;
  }

  font-family: 'open sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #676a6c;
  overflow-x: hidden;

  ul {
    list-style-type: none;
  }

  h4 {
    margin-top: 0px;
  }

  h2 {
    margin-top: 10px;
    font-size: 26px;
    font-weight: 100;
  }

  p {
    margin-top: 10px;

    b {
      font-weight: 700;
    }
  }

  .update-log {
    ol {
      display: block;
      list-style-type: decimal;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0;
      margin-inline-end: 0;
      padding-inline-start: 40px;
    }
  }
}

.left {
  float: left;
}

.right {
  float: right;
}

.cleafix {
  clear: both;
  overflow: hidden;
  content: '';
}

::v-deep .el-icon-s-custom:before {
  font-size: 30px;
}

.cornflowerblue {
  border-radius: 100%;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  margin-right: 10px;
}

::v-deep .el-table th {
  background: rgba(3, 146, 240, 1);
  color: #fff;
}

::v-deep .el-table .warning-row {
  background: rgb(169, 109, 205, 0.1);
}

::v-deep .el-table .success-row {
  background: rgba(108, 182, 201, 0.1);
}

::v-deep .el-table__body-wrapper {
  height: 324px;
  overflow-y: auto;
}

.two1 {
  // margin-left: 125px;
  margin-bottom: 20px;

  span {
    display: inline-block;
    line-height: 40px;
    width: 60px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #999999;
    // color: #1890ff;
  }

  span:nth-child(1) {
    border-radius: 6px 0 0 6px;
    border-right: none;
  }

  span:nth-child(2) {
    border-radius: 0;
    border-right: none;
  }

  span:nth-child(3) {
    border-radius: 0;
    border-right: none;
  }

  span:nth-child(4) {
    border-radius: 0 6px 6px 0;
    position: relative;
  }

  span:nth-child(4) .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
  }
}

.two {
  margin-left: 10px;
  margin-right: 125px;

  span {
    display: inline-block;
    line-height: 40px;
    width: 60px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #999999;
    // color: #1890ff;
  }

  span:nth-child(1) {
    border-radius: 6px 0 0 6px;
    border-right: none;
  }

  span:nth-child(2) {
    border-radius: 0;
    border-right: none;
  }

  span:nth-child(3) {
    border-radius: 0;
    border-right: none;
  }

  span:nth-child(4) {
    border-radius: 0 6px 6px 0;
    position: relative;
  }

  span:nth-child(4) .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
  }
}

.isActive {
  background: #1890ff;
  color: #ffffff !important;
  border: 1px solid #1890ff !important;

  // color: #fff;
}

::v-deep .el-range-input {
  // width: 84px;
}

::v-deep .el-input__inner {
  // width: auto !important;
}

.title {
  font-weight: bold;
  font-size: 16px;
}

.color {
  color: red;
  font-size: 18px;
}

.margin-b-10 {
  margin-bottom: 10px !important;
}
.cleafix {
  clear: both;
  overflow: hidden;
  content: '';
}
</style>
